import React from 'react'
import PropTypes from 'prop-types'
import {
  ControlsBox,
  FormAdd,
  FormInputNumberInputWrapper,
  FormSubtract,
  Input,
  Vr,
} from './component.styles'

const FormInputNumberInput = ({
  dataTestId,
  hasError,
  onChange,
  placeholder,
  value,
}) => {
  return (
    <FormInputNumberInputWrapper>
      <Input
        dataTestId={dataTestId}
        hasError={hasError}
        onChange={({ target: { value } }) => onChange(value)}
        placeholder={placeholder}
        type="number"
        value={value}
      />
      <ControlsBox>
        <FormSubtract
          onClick={() => onChange(Number(value) - 1)}
          onKeyUp={event => {
            if (event.key === 'Enter') {
              onChange(Number(value) - 1)
            }
          }}
        />
        <Vr noshade />
        <FormAdd
          onClick={() => onChange(Number(value) + 1)}
          onKeyUp={event => {
            if (event.key === 'Enter') {
              onChange(Number(value) + 1)
            }
          }}
        />
      </ControlsBox>
    </FormInputNumberInputWrapper>
  )
}

FormInputNumberInput.propTypes = {
  dataTestId: PropTypes.string,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default FormInputNumberInput
